<template>
    <div>
        <lv2-mangia-ristorante v-if="['mangia_ristorante', 'ordina_tavolo'].includes(this.currType)"
                               :init-people-number="this.initPeopleNumber"
                               :numero-persone="this.numeroPersone ? this.numeroPersone : 20"
                               @onPeopleNumberChange="this.onPeopleNumberChange"
        />
        <div v-if="this.currType !== 'ordina_tavolo' ">
            <div class="title">{{$t('ordine_scelta_data_titolo')}}</div>
            <options-carousel
                v-if="this.configurazione.giorni.length"
                :initial-idx="this.initial_day_idx"
                :entries="this.days_entries"
                @onSnapToItem="this.onSnapToItem"
            />
            <div class="pb-3" v-else>
                <h5>{{this.$t('nessuna_fascia_disponibile')}}</h5>
            </div>
        </div>
    </div>
</template>

<script>
import Lv2MangiaRistorante from "./Lv2MangiaRistorante";
import OptionsCarousel from "./OptionsCarousel";

export default {
    name: "Lv2",
    components: {OptionsCarousel, Lv2MangiaRistorante},
    props: ['initPeopleNumber', 'initDay', 'configurazione', 'currType', 'numeroPersone'],
    data() {
        return {
            day: null,
        };
    },
    created() {
        if (this.days_entries.length) {
            this.day = this.days_entries[this.initial_day_idx].value;

            if (this.currType === 'ordina_tavolo') {
                this.onSnapToItem(this.initial_day_idx);
            }
        }
    },
    computed: {
        days_entries: function () {
            return this.configurazione.giorni.map((giorno) => ({
                primaryText: giorno.week_day,
                secondaryText: giorno.day + ' ' + giorno.month,
                value: giorno,
            }));
        },
        initial_day_idx: function () {
            if (this.initDay) {
                const idx = this.days_entries.findIndex((entry) => entry.value.raw === this.initDay);
                return idx !== -1 ? idx : 0;
            } else {
                return 0;
            }
        }
    },
    methods: {
        onPeopleNumberChange: function (value) {
            this.$emit('onPeopleNumberChange', value);
        },
        onSnapToItem: function (index) {
            this.day = this.days_entries[index].value;
            this.$emit('onDayChange', this.day, this.day.raw);
        }
    }
}
</script>
